var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    { staticClass: "nav-item" },
    [
      _vm.hasActions
        ? [
            _c(
              "div",
              { staticClass: "wrapper-actions" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "nav-link",
                    attrs: { to: { name: _vm.item.route } },
                  },
                  [
                    _c("i", { class: ["nav-icon", _vm.item.icon] }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t(_vm.item.text)))]),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.actions, function (action, idx) {
                  return _c(
                    "router-link",
                    {
                      key: `item-action-${_vm.item.route}-${idx}`,
                      staticClass: "nav-link",
                      attrs: { to: { name: action.route } },
                    },
                    [
                      _c("i", { class: ["nav-icon action", action.icon] }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t(action.text)))]),
                    ]
                  )
                }),
              ],
              2
            ),
          ]
        : [
            _c(
              "router-link",
              {
                staticClass: "nav-link",
                attrs: { to: { name: _vm.item.route } },
              },
              [
                _c("i", { class: ["nav-icon", _vm.item.icon] }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t(_vm.item.text)))]),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }